<template>
    <div class="honor-system">
        <div class="banner">
            <img height="560px" src="../images/honor_system/banner.png" alt="">
            <div class="apply-btn">
                <img height="84px" src="../images/honor_system/apply_btn.png" @click="onApplyCoreUser" alt="">
            </div>
        </div>
        <p class="title">
            <img width="198px" height="211px" src="../images/honor_system/title2.png" alt="">
        </p>
        <div class="benefit-form">
            <!-- <img src="../images/honor_system/benefit_form.png" alt=""> -->
            <div class="table-header">
                <div class="line"></div>
                <div class="rights">权益</div>
                <div class="common-user">普通用户</div>
                <div class="core-user">核心用户</div>
            </div>
            <div class="table-body" v-for="honor in coreUserRights" :key="honor.name">
                <div class="honor-type">{{ honor.name }}</div>
                <div class="honor-content">
                    <div class="honor-item" v-for="honorItem in honor.value" :key="honorItem.rights">
                        <div class="honor-title" :title="honorItem.rights">{{ honorItem.rights }}</div>
                        <div class="common" :title="honorItem.common_user">{{ honorItem.common_user }}</div>
                        <div class="core" :title="honorItem.core_user">{{ honorItem.core_user }}</div>
                    </div>
                </div>
            </div>
        </div>
        <p class="title">
            <img width="216px" height="211px" src="../images/honor_system/title1.png" alt="">
        </p>
        <section class="whale-count-wrap">
            <div class="my-whale">
                <p class="title">鲸币要求</p>
                <ul class="whale-list">
                    <li
                        class="whale-item"
                        v-for="whaleItem in whaleList"
                        :key="whaleItem.bkb">
                        <p class="text">{{ whaleItem.text }}</p>
                        <p class="num">{{ userBalance[whaleItem.bkb] }}</p>
                        <img class="whale-badge" :src="whaleItem.imgUrl" alt="">
                        <div class="schedule" v-if="isAllBkb" :style="{ 'width': getSchedule(userBalance[whaleItem.bkb]), 'background': whaleItem.color }"></div>
                    </li>
                </ul>
                <a class="more" href="https://bk.tencent.com/s-mart/community/question/4022" target="_blank">
                    <span>获取更多鲸币</span>
                    <img class="arrows-right" height="36px" width="36px" src="../images/honor_system/arrows-right.png" alt="">
                </a>
                <img class="ball-left" src="../images/honor_system/ball-left.png" alt="">
                <img class="ball-right" src="../images/honor_system/ball-right.png" alt="">
            </div>
        </section>
        <div class="title">
            <img width="252px" height="211px" src="../images/honor_system/title3.png" alt="">
        </div>
        <div class="fame-wall">
            <ul class="user-list">
                <li
                    class="user-item"
                    v-for="(user, index) in coreUserList"
                    :key="index">
                    <img class="avatar" :src="user.profile_photo" alt="">
                    <p class="name">{{ user.name }}</p>
                    <p class="company" :title="user.company">{{ user.company }}</p>
                    <p class="position" :title="user.position">{{ user.position }}</p>
                    <p class="join-time">加入时间：{{ user.join_time }}</p>
                </li>
                <img class="badge-left" src="../images/honor_system/badge.png" alt="">
                <img class="badge-right" src="../images/honor_system/badge.png" alt="">
            </ul>
        </div>
        <honorDialog
            :isShow="isShow"
            @closeDialog="isShow = false">
        </honorDialog>
    </div>
</template>

<script>
import honorDialog from './honor_dialog.vue'

export default {
    components: {
        honorDialog
    },
    data() {
        return {
            whaleList: [
                {
                    text: '普通鲸币',
                    bkb: 'common_bkb',
                    imgUrl: require('../images/honor_system/whale.png'),
                    color: '#c8896f'
                }, {
                    text: '分享鲸币',
                    bkb: 'share_bkb',
                    imgUrl: require('../images/honor_system/share_whale.png'),
                    color: '#cfb77e'
                }, {
                    text: '专业鲸币',
                    bkb: 'professional_bkb',
                    imgUrl: require('../images/honor_system/specialty_whale.png'),
                    color: '#ecc86f'
                }
            ],
            coreUserRights: [],
            coreUserList: [],
            userBalance: {
                common_bkb: 500,
                share_bkb: 700,
                professional_bkb: 200
            },
            isAllBkb: 1400,
            isShow: false
        }
    },
    metaInfo () {
        let desc = `为鼓励和褒奖在腾讯蓝鲸智云社区做出贡献的运维同仁，促进运维技术的分享和传播，我们特别推出了「腾讯蓝鲸智云社区全新荣誉体系」。
如果你对当下的运维技术或行业发展有深刻的见解，亦或是在运维领域有着丰富的技术、业务经验沉淀，我们期待你的加入，通过分享优质内容或在社区积极发声，一起共建运维生态，共创运维价值！
“核心用户”是社区里涌现的一批技术布道师，他们在运维技术、研发与运维、蓝鲸与开源产品等运维领域，通过分享高质量的内容，编写高质量技术文章等方式，与社区成员共同学习。“核心用户”是蓝鲸社区认定的运维技术先驱与技术领袖，享受最高的社区荣誉和权益！`
        desc = desc.replace(/\n/g, '')
        return {
            title: '荣誉体系|蓝鲸智云',
            meta: [
                {
                    name: 'keywords',
                    content: '腾讯，腾讯运维，蓝鲸，蓝鲸智云，用户荣誉体系，核心用户，DevOps，腾讯云，腾讯课堂，运维解决方案，运维课程，运维自动化，运维产品，游戏，运营，运维，实时计算，监控，大数据，无人值守，开区，发布，扩容，缩容'
                },
                {
                    name: 'description',
                    content: desc
                }
            ]
        }
    },
    computed: {
        isLogin () {
            return this.$store.state.isLogin
        }
    },
    mounted() {
        this.getUserRights()
        this.getHonorUserList()
    },
    methods: {
        // 获取荣誉
        async getUserRights () {
            const res = await axios.get(myUrl + 'page/layer/CoreUserRights/info/')
            if (res.data && res.data.result) this.coreUserRights = res.data.data.extra_info
        },
        // 获取荣誉用户名单
        async getHonorUserList () {
            const res = await axios.get(myUrl + 'page/layer/CoreUserList/info/')
            if (res.data && res.data.result) this.coreUserList = res.data.data.extra_info[0].value
        },
        // 获取进度
        getSchedule (num) {
            const percentage = ((num / this.isAllBkb) * 100).toFixed(2) || 0
            return `${percentage}%`
        },
        // 申请成为核心用户
        async onApplyCoreUser () {
            try {
                if (!this.isLogin) {
                    axios.get(myUrl + 'login/test/')
                    return
                }
                this.isShow = true
            } catch (error) {
                console.warn(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .honor-system {
        background: #fff;
        margin: 0 auto;
        .banner {
            position: relative;
            height: 560px;
            margin-bottom: 20px;
            text-align: center;
            background: #edbc90;
            background: linear-gradient(to right, #f3c63b 50%, #edbc90 50%);
            .apply-btn {
                width: 1542px;
                height: 84px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 78px;
                margin: 0 auto;
                padding-left: 155px;
                text-align: left;
                img {
                    cursor: pointer;
                }
            }
        }
        .title {
            text-align: center;
        }
        .benefit-form {
            width: 1200px;
            height: 1358px;
            margin: 28px auto 100px;
            .table-header {
                height: 58px;
                width: 100%;
                line-height: 58px;
                color: #83482c;
                font-weight: bold;
                font-size: 16px;
                display: flex;
                text-align: center;
                .rights {
                    flex: 1;
                    background-color: #ffe4c8;
                }
                .line {
                    border-top-left-radius: 8px;
                    width: 142px;
                    height: 100%;
                    background-color: #ffe4c8;
                    border-right: 1px solid #dcdee5;
                }
                .common-user {
                    width: 199px;
                    background-color: #ffe4c8;
                    border-left: 1px solid #dcdee5;
        
                }.core-user {
                    width: 194px;
                    background-color: #f6c02b;
                    border-top-right-radius: 8px;
                }
            }
            .table-body {
                width: 100%;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #dcdee5;
                border-left: 1px solid #dcdee5;
                letter-spacing: 0.1em;
                .honor-type {
                    width: 140px;
                    text-align: center;
                    font-weight: 600;
                    font-size: 18px;
                    color: #313238;
                    height: 100%;
                    padding: 10px;
                }
                .honor-content {
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    border-left: 1px solid #dcdee5;
                    color: #45464b;
                    font-size: 16px;
                    overflow: hidden;
                    .honor-item {
                        display: flex;
                        height: 58px;
                        line-height: 58px;
                        border-bottom: 1px solid #dcdee5;
                        .honor-title {
                            flex: 1;
                            margin-right: 5px;
                            padding-left: 32px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            
                        }
                        .common {
                            width: 194px;
                            margin-right: 5px;
                            text-align: center;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            border-left: 1px solid #dcdee5;
                        }
                        .core {
                            text-align: center;
                            background-color: #fdf9ec;
                            width: 194px;
                            border-right: 2px solid #f6c02b;
                            border-left: 2px solid #f6c02b;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .honor-item:nth-last-of-type(1){
                        border: none;
                    }
                }
                
            }
            .table-body:nth-last-of-type(1) {
                .honor-content:nth-last-of-type(1) {
                    .honor-item:nth-last-of-type(1) {
                        .core {
                            border-right: 2px solid #f6c02b;
                            border-left: 2px solid #f6c02b;
                            border-bottom: 2px solid #f6c02b;
                        }
                    }
                }

            }
            img {
                height: 100%;
                width: 100%;
            }
        }
        .whale-count-wrap {
            height: 523px;
            background: linear-gradient(to right, #fff4d6, #fff7e0);
            margin: 94px 0 134px;
            .my-whale {
                position: relative;
                width: 1200px;
                height: 100%;
                color: #313238;
                margin: 0 auto;
                padding-top: 148px;
                .count-img {
                    position: absolute;
                    left: 0;
                    top: -53px;
                    width: 1200px;
                    height: 161px;
                }
                .title {
                    text-align: center;
                    font-size: 28px;
                    margin-bottom: 30px;
                }
                .ball-left {
                    position: absolute;
                    top: 180px;
                    left: -300px;
                    width: 180px;
                }
                .ball-right {
                    position: absolute;
                    top: 170px;
                    right: -150px;
                    width: 220px;
                }
            }
            .whale-list {
                display: flex;
                align-items: center;
                .whale-item {
                    width: 384px;
                    height: 160px;
                    z-index: 10;
                    position: relative;
                    background: #ffffff;
                    border-radius: 2px;
                    margin-right: 24px;
                    padding: 22px 0 0 26px;
                    border-bottom: 6px solid #fff6dd;
                    box-shadow: 0px 2px 8px 0px rgba(80,53,0,0.24);
                    .text {
                        font-size: 20px;
                        color: #6d6154;
                        line-height: 28px;
                    }
                    .num {
                        font-size: 56px;
                        color: #313238;
                        line-height: 78px;
                    }
                    .whale-badge {
                        position: absolute;
                        top: 25px;
                        right: 26px;
                        width: 88px;
                        height: 89px;
                    }
                    .schedule {
                        position: absolute;
                        left: 0;
                        bottom: -6px;
                        height: 6px;
                        border-radius: 0px 0px 0px 2px;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .more {
                width: 260px;
                height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                color: #ffffff;
                background: #3a84ff;
                margin: 48px auto 0;
                cursor: pointer;
                border-radius: 28px;
                box-shadow: 0px 4px 10px 0px rgba(223,220,217,0.60);
                .arrows-right {
                    position: relative;
                    top: 2px;
                }
            }
        }
        .fame-wall {
            margin-top: 8px;
            min-height: 1512px;
            width: 100%;
            padding: 122px 0 100px;
            background: linear-gradient(to left, #fdd993, #fff1c4);
            .user-list {
                width: 1160px;
                position: relative;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin: 0 auto;
                .user-item {
                    width: 260px;
                    height: 392px;
                    z-index: 10;
                    padding: 20px;
                    color: #6e6863;
                    margin: 0 40px 36px 0;
                    background-image: url('../images/honor_system/honor_box.png');
                    background-size: cover;
                    .avatar {
                        width: 220px;
                        height: 220px;
                        border-radius: 6px;
                        margin-bottom: 35px;
                    }
                    .name {
                        font-size: 24px;
                        color: #313238;
                        line-height: 33px;
                        margin-bottom: 5px;
                    }
                    .company, .position, .join-time {
                        line-height: 22px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                    &:nth-child(4n) {
                        margin-right: 0;
                    }
                }
                .badge-left {
                    position: absolute;
                    width: 700px;
                    top: -80px;
                    left: -650px;
                    opacity: 0.3;
                }
                .badge-right {
                    position: absolute;
                    width: 600px;
                    top: 550px;
                    right: -700px;
                    opacity: 0.3;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// honorSystem.vue?8d5b6e3a